export async function getAllTeams() {
    const response = await fetch('/api/teams/getAll');
    return await response.json();
}
export async function getOneTeam(team_id) {
    const response = await fetch('/api/teams/getOne/' + team_id);
    return await response.json();
}